import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Box } from '@mui/material';
import getColorPresets from '@/utils/getColorPresets';
import useMobile from '@/hooks/useMobile';
import { useSaturated } from '@/store';
import { SATURATED_TIME_SECONDS } from '@/store/saturated/useSaturated';
import useCountdown from '@/hooks/useCountdown';
import Iconify from '@/components/Iconify';
import dayjs from 'dayjs';
import ConfirmTriesDialog from './ConfirmTriesDialog';
import { AlertDialog } from '@/components/dialogs';
import { useRouter } from 'next/router';
import { useModals } from '@mattjennings/react-modal-stack';
import Cookies from 'js-cookie';
import { clearQueueFairSession } from '@/utils/queueFair';

function Timer({ variant = 'default' }) {
  const { t } = useTranslation();
  const color = getColorPresets('orange');
  const router = useRouter();
  const { isMobile } = useMobile();
  const { openModal } = useModals();
  const { start: startDate, tries } = useSaturated();

  const { timeLeft, timeLeftString, start } = useCountdown({
    onTimeExpired: () => {
      openModal(AlertDialog, {
        title: t('checkout.home.saturated.alert'),
        text: t('checkout.home.saturated.alertText'),
        acceptLabel: t('checkout.global.acceptLabel'),
        blockClose: true,
        closeTriggersConfirm: true,
        onConfirm: () => {
          clearQueueFairSession();
          router.reload();
        },
      });
    },
    onAlarm: (alarm) => {
      openModal(ConfirmTriesDialog, {
        tries,
        variant: 'timeOut',
      });
    },
    alarms: ['00:45'],
  });

  useEffect(() => {
    if (startDate && variant !== 'icon') {
      start(dayjs(startDate), timeLeft || SATURATED_TIME_SECONDS);
    }
  }, [startDate]);
  return (
    <>
      {variant === 'default' ? (
        <Typography
          sx={{
            flex: 1,
            fontWeight: 600,
            color: color.light,
            fontSize: isMobile ? '18px' : '24px',
            width: '70px',
          }}
          variant="caption"
          component="div"
        >
          {timeLeftString}
        </Typography>
      ) : (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              width: '24px',
            }}
          >
            <Typography
              sx={{
                flex: 1,
                fontWeight: 600,
                color: color.light,
                width: '24px',
                marginTop: '2px',
              }}
              variant="caption"
              component="div"
            >
              {variant === 'icon' && (
                <Iconify width={32} height={33} icon={'mdi:clock-outline'} />
              )}
            </Typography>
          </Box>
          <Box
            sx={{
              width: '70px',
              ml: 2,
            }}
          >
            <Typography
              sx={{
                flex: 1,
                fontWeight: 600,
                color: color.light,
                fontSize: '32px',
                width: '70px',
              }}
              variant="caption"
              component="div"
            >
              {timeLeftString}
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
}

export default Timer;
